import {reverseShortDate} from '../../../common/constants/datesFormat';
import {convertDateToSpecificFormat} from '../../../common/util/date';
import {COLORS, typesOrders} from './constants';

export const getColors = (statusId) => {
  if (statusId === typesOrders.Anuladas) {
    return COLORS.yellow;
  } else if (statusId === typesOrders.Cerradas) {
    return COLORS.red;
  } else if (statusId === typesOrders.NoFacturables) {
    return COLORS.blue;
  }
  return COLORS.green;
};

export const getStatus = (statusId) => {
  if (statusId === typesOrders.Anuladas) {
    return 'Anulada';
  } else if (statusId === typesOrders.Cerradas) {
    return 'Cerrada';
  } else if (statusId === typesOrders.NoFacturables) {
    return 'No facturable';
  }
  return 'Abierta';
};

export const getUrl = (start, end, type) => {
  return `?start=${convertDateToSpecificFormat(
    start,
    reverseShortDate
  )}&end=${convertDateToSpecificFormat(end, reverseShortDate)}&type=${type}`;
};

export const getTypeOrder = (type) => {
  if (type === 'DS') {
    return 'PDS';
  } else if (type === 'AC') {
    return 'Accesorios';
  } else if (type === 'HU') {
    return 'Hunter';
  } else if (type === 'CC') {
    return 'Control de Calidad';
  }
  return '---';
};

export const getCssBoards = (select, orderValer) => {
  if (select === orderValer) {
    return 'block';
  } else if (orderValer && !select) {
    return 'block';
  }
  return 'none';
};
